import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Camera, Upload } from 'lucide-react';
import { motion } from 'framer-motion';
interface PhotoUploadStepProps {
  onNext: (data: any) => void;
}
export function PhotoUploadStep({
  onNext
}: PhotoUploadStepProps) {
  const [formData, setFormData] = useState({
    height: '',
    bust: '',
    waist: '',
    hips: '',
    inseam: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const isFormValid = Object.values(formData).every(val => val !== '');
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="max-w-2xl mx-auto bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-225">
      <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-primary mb-8 text-center" data-id="element-226">
        Upload Your Photo & Measurements
      </h2>

      <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-227">
        {/* Photo Upload Area */}
        <div className="border-2 border-dashed border-accent/30 rounded-xl bg-primary/30 flex flex-col items-center justify-center p-8 hover:border-accent/60 transition-colors cursor-pointer group h-full min-h-[250px]" data-id="element-228">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm group-hover:scale-110 transition-transform" data-id="element-229">
            <Camera className="w-8 h-8 text-accent" data-id="element-230" />
          </div>
          <p className="text-text-primary font-medium mb-1" data-id="element-231">Upload Photo</p>
          <p className="text-xs text-text-muted text-center" data-id="element-232">
            Full body shot works best.
            <br data-id="element-233" />
            JPG or PNG up to 5MB.
          </p>
        </div>

        {/* Measurements Form */}
        <div className="space-y-4" data-id="element-234">
          <div data-id="element-235">
            <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-236">
              Height
            </label>
            <select name="height" value={formData.height} onChange={handleChange} className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-all bg-white" data-id="element-237">
              <option value="" data-id="element-238">Select height</option>
              {['4\'10"', '4\'11"', '5\'0"', '5\'1"', '5\'2"', '5\'3"', '5\'4"'].map(h => <option key={h} value={h} data-id="element-239">
                  {h}
                </option>)}
            </select>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-240">
            <div data-id="element-241">
              <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-242">
                Bust (in)
              </label>
              <input type="number" name="bust" value={formData.bust} onChange={handleChange} placeholder="34" className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-all" data-id="element-243" />
            </div>
            <div data-id="element-244">
              <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-245">
                Waist (in)
              </label>
              <input type="number" name="waist" value={formData.waist} onChange={handleChange} placeholder="28" className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-all" data-id="element-246" />
            </div>
            <div data-id="element-247">
              <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-248">
                Hips (in)
              </label>
              <input type="number" name="hips" value={formData.hips} onChange={handleChange} placeholder="38" className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-all" data-id="element-249" />
            </div>
            <div data-id="element-250">
              <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-251">
                Inseam (in)
              </label>
              <input type="number" name="inseam" value={formData.inseam} onChange={handleChange} placeholder="26" className="w-full px-4 py-2 rounded-lg border border-gray-200 focus:border-accent focus:ring-1 focus:ring-accent outline-none transition-all" data-id="element-252" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-4 border-t border-gray-100" data-id="element-253">
        <Button onClick={() => onNext(formData)} disabled={!isFormValid} className="w-full md:w-auto" data-id="element-254">
          Continue
        </Button>
      </div>
    </motion.div>;
}